import axiosInstance from "../api.axiosInstance"
import type { ImageryResponseDto } from "../dto/imagery.dto"

export class ImageryService {
  /**
   * Fetches imagery for a specific provider on-demand.
   * This is used when a user selects a non-Google imagery provider
   * that hasn't been fetched yet.
   */
  async fetchImageryForProvider(
    siteId: string,
    provider: `nearmap`,
  ): Promise<ImageryResponseDto[]> {
    try {
      const response = await axiosInstance.get<ImageryResponseDto[]>(
        `/imagery/v1/site/${siteId}/provider/${provider}`,
      )
      return response.data
    } catch (error: unknown) {
      const axiosError = error as { response?: { status: number } }
      if (axiosError.response?.status === 404) {
        throw new Error(`Site not found`)
      }
      if (axiosError.response?.status === 400) {
        throw new Error(`Invalid imagery provider`)
      }
      throw error
    }
  }
}

export const imageryService = new ImageryService()
